import styles from './styles.module.css';
import RoomAndUsersColumn from './room-and-users'; // Add this
import SendMessage from './send-message';
import MessagesReceived from './messages';
import "../../css/chat.css";

const Chat = ({ username, setUsername, room, setRoom, socket }) => {
  // const roomJoined = JSON.parse(localStorage.getItem("roomJoined"));
  // const usernameJoined = JSON.parse(localStorage.getItem("usernameJoined"));

  // const roomJoined = localStorage.getItem("roomJoined");
  // const usernameJoined = localStorage.getItem("usernameJoined");

  // console.log("roomJoined-->>chat", roomJoined);
  // console.log("usernameJoined-->>chat", usernameJoined);

  // if ( ((typeof roomJoined !== undefined) && (roomJoined !== '')) && ((typeof usernameJoined !== undefined) && (usernameJoined !== '')) ) {
  //   socket.emit('join_room', { usernameJoined, roomJoined });
  // }

  return (
    <div className={styles.chatContainer}>
      <RoomAndUsersColumn socket={socket} username={username} setUsername={setUsername} room={room} setRoom={setRoom} />

      <div>
        <MessagesReceived socket={socket} username={username} />
        <SendMessage socket={socket} username={username} room={room} />
      </div>
    </div>
  );
};

export default Chat;